import { IDatasourceRevision } from '../types/IDatasourceRevision';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { Request } from '../../../ts/ServerApi/requests/Request';

export interface IGetDatasourceVersionsParams extends IGetItemsParams {
}

export interface IGetDatasourceVersionsResult extends IGetItemsResult {
  versions: IDatasourceRevision[];
}

export class GetDatasourceVersionsRequest extends Request<IGetDatasourceVersionsParams, IGetDatasourceVersionsResult> {
  constructor(params: IGetDatasourceVersionsParams) {
    super('getDatasourceVersions', params);
  }
}
